module.exports = __webpack_public_path__ + "static/media/GEMMABanner728x90.519df127.jpg";